import { ApiErrorCode, ApiResponse, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

import {
  mapToUpdatePermissionsRequest,
  mapUserGroupPermissionsListFromResponse,
} from '../mappers/permission.mapper';
import { UserGroupPermissions } from '../types/permission';
import { UpdateUserGroupPoliciesRequest } from '../types/request/permission-request';
import { UserGroupPoliciesResponse } from '../types/response/permission-response';

/**
 * Fetches all user group policies for the organization
 * Returns complete list in single request (no pagination)
 */
export const getPermissions = async (): Promise<UserGroupPermissions[]> => {
  const endpoint = '/api/opsium-policies';

  const response = await withApiErrorHandler(endpoint, ApiErrorCode.PERMISSIONS_LOAD_FAILED, () =>
    axiosInstance.get<ApiResponse<UserGroupPoliciesResponse[]>>(endpoint)
  );

  return mapUserGroupPermissionsListFromResponse(response);
};

/**
 * Updates user group policies for the organization
 * Must include all organization user groups except 'Super Admin' which is protected
 *
 * Returns nothing — the caller refetches via `getPermissions`.
 */
export const updatePermissions = async (
  userGroupPermissions: UserGroupPermissions[]
): Promise<void> => {
  const endpoint = '/api/opsium-policies';

  const requestBody: UpdateUserGroupPoliciesRequest =
    mapToUpdatePermissionsRequest(userGroupPermissions);

  await withApiErrorHandler(endpoint, ApiErrorCode.PERMISSIONS_UPDATE_FAILED, () =>
    axiosInstance.patch<ApiResponse<never>>(endpoint, requestBody)
  );
};
